import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #423f9a;
  height: 24px;
  width: 24px;
`
export const AssistanceIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 9.7C5 9.4 5.1 9.1 5.2 8.8C5.7 7.1 7.4 6 9.3 6.2C10.2 6.3 11 6.7 11.7 7.3C11.8 7.4 11.9 7.5 12 7.6C12.2 7.4 12.4 7.2 12.6 7C14.9 5 18.4 6.2 19 9.2C19.2 10.5 18.9 11.6 18.1 12.6C17.5 13.3 16.8 13.9 16.2 14.5C15 15.5 13.8 16.6 12.6 17.6C12.3 17.9 12 17.9 11.6 17.6C10 16.3 8.3 14.9 6.8 13.4C6.3 12.9 5.8 12.4 5.5 11.8C5.2 11.5 5 11 5 10.4V10.3C5 10.1 5 9.9 5 9.7ZM12 16.4L12.1 16.3C13.1 15.5 14 14.7 15 13.8C15.7 13.2 16.3 12.6 17 11.9C17.7 11.1 18 10.2 17.7 9.1C17.1 7.2 14.8 6.6 13.3 8C13 8.3 12.8 8.5 12.5 8.8C12.2 9.1 11.8 9.1 11.5 8.8C11.3 8.6 11 8.3 10.8 8.1C10.2 7.5 9.4 7.2 8.6 7.3C7 7.6 5.9 9.1 6.3 10.6C6.4 11.3 6.8 11.8 7.3 12.3C8.4 13.4 9.5 14.3 10.6 15.3C11.1 15.7 11.5 16 12 16.4Z" />
      <path d="M13.4008 11.6H12.5008V10.7C12.5008 10.4 12.2008 10.1 11.9008 10.1C11.6008 10.1 11.3008 10.4 11.3008 10.7V11.6H10.4008C10.1008 11.6 9.80078 11.9 9.80078 12.2C9.80078 12.5 10.1008 12.8 10.4008 12.8H11.3008V13.7C11.3008 14 11.6008 14.3 11.9008 14.3C12.2008 14.3 12.5008 14 12.5008 13.7V12.8H13.4008C13.7008 12.8 14.0008 12.5 14.0008 12.2C14.0008 11.8 13.7008 11.6 13.4008 11.6Z" />
    </Svg>
  )
}
